export const INSTANT_SERVICE_LOADING = 'INSTANT_SERVICE_LOADING';
export const INSTANT_SERVICE_SUCCESS = 'INSTANT_SERVICE_SUCCESS';
export const INSTANT_SERVICE_ERROR = 'INSTANT_SERVICE_ERROR';
export const INSTANT_SERVICE_CLEAR_ERROR = 'INSTANT_SERVICE_CLEAR_ERROR';
export const INSTANT_SERVICE_CLEAR_APPLICATION = 'INSTANT_SERVICE_CLEAR_APPLICATION';

export const INSTANT_SERVICE_FETCH_APPLICATION_SUCCESS = 'INSTANT_SERVICE_FETCH_APPLICATION_SUCCESS';
export const INSTANT_SERVICE_FETCH_DOCUMENTS_SUCCESS = 'INSTANT_SERVICE_FETCH_DOCUMENTS_SUCCESS';
export const INSTANT_SERVICE_FETCH_BREAKDOWN_SUCCESS = 'INSTANT_SERVICE_FETCH_BREAKDOWN_SUCCESS';